import { Component, Inject, OnInit } from '@angular/core';
import { OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { VIDEO_SOURCE, HowtoType } from '@app/constants';
import { BehaviorSubject } from 'rxjs';

export interface HowToPopupData {
  type: string;
}

@Component({
  selector: 'app-how-to-popup',
  templateUrl: './how-to-popup.component.html',
  styleUrls: ['./how-to-popup.component.scss']
})
export class HowToPopupComponent implements OnInit {
  type = HowtoType;
  activeSlide: SlidesOutputData = {
    startPosition : 0
  };
  customOptions: OwlOptions = {
    loop: false,
    autoHeight: true,
    autoWidth: false,
    mergeFit: true,
    dots: true,
    items: 1,
    dotsEach: 1,
  };
  slidesStore: any;
  messageDrawBehavior$ = new BehaviorSubject<string[]>([]);
  messageReachBoxLimit = [];

  constructor(
    public dialogRef: MatDialogRef<HowToPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HowToPopupData,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.translateService.get('CHART_MANAGER.HOWTO_POPUP.FIRST_DRAW.MESSAGE')
      .subscribe(data => this.messageDrawBehavior$.next(data));

    if (this.data.type === HowtoType.FIRST_DRAW) {
      this.slidesStore = VIDEO_SOURCE.FIRST_DRAW.map((srcUrl) => ({
        src: srcUrl,
        message: this.messageDrawBehavior$.value
      }));
    } else if (this.data.type === HowtoType.FIRST_REACH_BOX_LIMIT) {
      this.translateService.get('CHART_MANAGER.HOWTO_POPUP.FIRST_REACH_BOX_LIMIT.MESSAGE')
        .subscribe(data =>
          this.messageReachBoxLimit = this.messageDrawBehavior$.value.concat(data)
        );
      this.slidesStore = VIDEO_SOURCE.FIRST_REACH_BOX_LIMIT.map((srcUrl) => ({
        src: srcUrl,
        message: this.messageReachBoxLimit
      }));
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getPassedData(data: SlidesOutputData) {
    this.activeSlide = data;
  }
}
